export const DIALOG_TYPE = 'loading-dialog';
